import * as React from 'react';
import { Appbar } from 'react-native-paper';
import { View, StyleSheet, Image } from 'react-native';
// import { DrawerActions } from '@react-navigation/native';
import { useNavigation } from '@react-navigation/core';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParams } from '../Home';
import { useNav } from '../../providers/NavProvider';
import UserAvatar from './UserAvatar';
import AvatarMenu from './AvatarMenu';
import NotificationBell from './NotificationBell';
import NotificationPanel from './NotificationPanel';
import { useAppConfig } from '../../providers/AppConfigProvider';

interface TopbarProps {
    currentRoute?: string;
}

const Topbar: React.FC<TopbarProps> = ({ currentRoute }) => {
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParams>>();
    const currentRouteName = currentRoute;
    const { currentLeafObj } = useNav();
    const { EnableNotifications } = useAppConfig();
    const [notifOpen, setNotifOpen] = React.useState(false);

    return (
        <View style={{backgroundColor:'#4BB75F', zIndex: 1000}}>
            {/* {currentLeafObj ? */}
            {/* // <Appbar> */}
            <Appbar.Header elevated style={{ zIndex: 1000 }}>
                <View style={{backgroundColor:'#4BB75F', flexDirection: 'row', justifyContent: 'space-between', width: "100%", alignItems: 'center', zIndex: 1000 }}>
                    {/* <Appbar.Action icon="menu" onPress={() => { navigation.dispatch(DrawerActions.toggleDrawer()) }} /> */}
                    <View style={{ minWidth: 50 }}>
                        {
                            (navigation.canGoBack() && (
                                (currentLeafObj && currentLeafObj.path.split('-').length > 2) ||
                                currentRouteName === 'PortfolioSideNav' ||
                                currentRouteName === 'Portfolio' ||
                                currentRouteName === 'PortfolioPaper'
                            )) && <Appbar.Action icon="arrow-left" onPress={() => { navigation.goBack() }} />
                        }
                        {/* <Appbar.Content title={currentLeafObj ? currentLeafObj.title : 'Greenport'} ></Appbar.Content> */}
                    </View>
                    <Image style={styles.tinyLogo} source={require('../../assets/Greenport-white.png')}></Image>
                    {/* <Image style={styles.tinyLogo} source={require('../../assets/logo.png')}></Image> */}
                    {/* <Appbar.Action icon="calendar" onPress={() => { }} />
            <Appbar.Action icon="magnify" onPress={() => { }} /> */}
                    {/* <UserAvatar/> */}
                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, paddingRight: 8 }}>
                        {EnableNotifications && (
                            <NotificationBell onPress={() => setNotifOpen(!notifOpen)} active={notifOpen} />
                        )}
                        <AvatarMenu />
                    </View>
                </View>
            </Appbar.Header>
            {EnableNotifications && (
                <NotificationPanel visible={notifOpen} onClose={() => setNotifOpen(false)} />
            )}
            {/* // </Appbar> */}
            {/* : <></>
            } */}
        </View>
    );
};


const styles = StyleSheet.create({

    tinyLogo: {
        margin:14,
        width: 216,
        height:30,
        alignSelf: 'center'
    }

});
export default Topbar;